export default {
  setDropdownMenuList(rawDataList) {
    return rawDataList.map(({
      id, email, name
    }) => ({
      id,
      name: `${name} (${email})`,
    }));
  },
};
